<template>
  <div id="app">
    <AppBrandWarning/>
    <AppHeader />
    <AppNavigation />
    <vue-progress-bar></vue-progress-bar>
    <div class="container-fluid">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/styles/_base.scss";
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


<script>
// @ is an alias to /src
import AppHeader from '@/components/AppHeader/AppHeader.vue';
import AppNavigation from '@/components/AppNavigation/AppNavigation.vue';
import AppBrandWarning from '@/components/AppBrandWarning/AppBrandWarning.vue';

// Code is missing export
export default {
  components: {
    AppHeader,
    AppNavigation,
    AppBrandWarning
    },
    created() {
      window.addEventListener('beforeunload', this.leaving);
    },
    mounted() {
        this.$root.$emit('getDashboardData');
        this.$store.dispatch('getCustomers');
    }
};
</script>
